import React, { FunctionComponent } from 'react';
import { UNKNOWN, formatName } from './propertyFormatter';
import './PropertyChange.scss';

export enum ChangeType {
  ADD = 'add',
  DELETE = 'delete',
  EDIT = 'edit',
  CHANGE = 'change',
}

export interface ChangeInfo {
  changeType: ChangeType;
  name: string;
  values: string[];
  showName?: boolean;
}

/**
 * Returns an <li> element with the change description.
 * @param param0
 * @returns
 */
export const ChangeDescription: FunctionComponent<ChangeInfo> = ({
  changeType,
  name,
  values,
  showName = true,
}): JSX.Element => {
  const formattedName = formatName(name);
  if (
    [ChangeType.ADD, ChangeType.DELETE, ChangeType.EDIT].includes(changeType)
  ) {
    let action;
    if (changeType === ChangeType.ADD) {
      action = 'Added';
    } else if (changeType === ChangeType.DELETE) {
      action = 'Removed';
    } else {
      action = 'Edited';
    }
    const value = values[0] ?? 'unknown';
    if (value !== UNKNOWN && value !== 'Yes' && value !== 'No') {
      return (
        <li key={name}>
          {action} {formattedName} with value{' '}
          <span className="offer-prop-change-value">{value}</span>
        </li>
      );
    }
    return (
      <li key={name}>
        {action} {formattedName}
      </li>
    );
  }
  if (changeType === ChangeType.CHANGE) {
    const changeText = showName ? `Changed ${formattedName}` : 'Changed';
    if (values.length === 1) {
      return (
        <li key={name}>
          {changeText} to{' '}
          <span className="offer-prop-change-value">{values[0]}</span>
        </li>
      );
    }
    if (values.length === 2) {
      return (
        <li key={name}>
          {changeText} from{' '}
          <span className="offer-prop-change-value">{values[0]}</span> to{' '}
          <span className="offer-prop-change-value">{values[1]}</span>
        </li>
      );
    }
  }
  return <li />;
};
